'use client';

import type { ComponentProps, ReactNode } from 'react';
import { InnerPageContainer } from '../../../InnerPageContainer/InnerPageContainer';
import { usePurchaseDetails } from '../context/PurchaseDetailsContext';

type PurchaseDetailsContainerProps = ComponentProps<'main'> & {
  footer?: ReactNode;
};

/**
 * Page shell (tracking attributes + grid layout) with a `footer` slot rendered outside the grid.
 * Reads its data from `PurchaseDetailsProvider`, so it must be rendered inside it.
 */
function PurchaseDetailsContainer({ children, footer, ...props }: PurchaseDetailsContainerProps) {
  const { lotteryName } = usePurchaseDetails();

  return (
    <InnerPageContainer data-track-feature="Lottery Purchases" data-track-container="Order" data-track-product={lotteryName} {...props}>
      <div className="ll-grid-container gap-y-7 pt-4 pb-10 sm-md:pt-10 sm-md:[--ll-container-padding:40px]">{children}</div>
      {footer}
    </InnerPageContainer>
  );
}

export { PurchaseDetailsContainer, type PurchaseDetailsContainerProps };
